import React, { useEffect, useState } from "react";
import { $host } from "../../../../http";
import ParagraphCard from "../../components/cards/ParagraphCard";
import ParagraphModal from "../../components/modal/ParagraphModal";

const Paragraphs = () => {
    const [paragraphs, setParagraphs] = useState([]);
    const [courses, setCourses] = useState({});
    const [error, setError] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [currentCourseId, setCurrentCourseId] = useState(null);
    const [editingParagraph, setEditingParagraph] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const paragraphsResponse = await $host.get("/api/teachers/paragraphs", { withCredentials: true });
                setParagraphs(paragraphsResponse.data);

                const coursesResponse = await $host.get("/api/teachers/courses", { withCredentials: true });
                const coursesData = coursesResponse.data;

                const coursesMap = {};
                coursesData.forEach(course => {
                    coursesMap[course.id] = course;
                });

                setCourses(coursesMap);
            } catch (err) {
                setError(err.response?.data?.message || err.message);
            }
        };

        fetchData();
    }, []);

    const handleDeleteParagraph = async (paragraphId) => {
        try {
            await $host.delete(`/api/teachers/paragraphs/${paragraphId}`, { withCredentials: true });
            setParagraphs(prev => prev.filter(p => p.id !== paragraphId));
        } catch (error) {
            console.error("Ошибка удаления параграфа:", error.response?.data?.message || error.message);
        }
    };

    const handleOpenCreateModal = (courseId) => {
        setCurrentCourseId(courseId);
        setEditingParagraph(null);
        setModalOpen(true);
    };

    const handleOpenEditModal = (paragraph) => {
        setEditingParagraph(paragraph);
        setModalOpen(true);
    };

    const handleSaveParagraph = (newParagraph) => {
        if (editingParagraph) {
            setParagraphs(prev => prev.map(p => (p.id === newParagraph.id ? newParagraph : p)));
        } else {
            setParagraphs(prev => [...prev, newParagraph]);
        }
    };

    const groupedParagraphs = paragraphs.reduce((acc, paragraph) => {
        if (!acc[paragraph.course_id]) {
            acc[paragraph.course_id] = [];
        }
        acc[paragraph.course_id].push(paragraph);
        return acc;
    }, {});

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-4">Список параграфов</h2>
            {error && <p className="text-red-500">Ошибка: {error}</p>}
            {paragraphs.length === 0 ? (
                <p className="text-gray-600">Загрузка или нет данных...</p>
            ) : (
                <div className="space-y-6">
                    {Object.keys(groupedParagraphs).map(courseId => (
                        <div key={courseId}>
                            <div className="flex justify-between items-center mb-2">
                                <h3 className="text-xl font-bold">{courses[courseId]?.title || "Неизвестный курс"}</h3>
                                <button
                                    className="bg-green-500 text-white px-4 py-2 rounded"
                                    onClick={() => handleOpenCreateModal(courseId)}
                                >
                                    + Добавить параграф
                                </button>
                            </div>
                            <div className="flex flex-wrap gap-4">
                                {groupedParagraphs[courseId].map((paragraph) => (
                                    <ParagraphCard
                                        key={paragraph.id}
                                        id={paragraph.id}
                                        title={paragraph.title}
                                        description={paragraph.description}
                                        link={`/paragraphs/${paragraph.id}`}
                                        themes={paragraph.themes || []} // Теперь передаём `themes`
                                        optionsEnabled={true}
                                        onDelete={handleDeleteParagraph}
                                        onEdit={handleOpenEditModal}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <ParagraphModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                paragraph={editingParagraph}
                courseId={currentCourseId}
                onSave={handleSaveParagraph}
            />
        </div>
    );
};

export default Paragraphs;
